var ko                = require('knockout')
,   _                 = require('lodash');

var conditionalFilterValues = function (args){ // (thisFilterName, parentFilterName , filterNames, galleryFilters, hasCategoryFilters, allBrandNames, categories) {
        
    console.log('humm 2', args);

    if(args.parentFilterName === args.filterNames.root){
        console.log('FINISHED - at the top level', args.allBrandNames);
        return args.allBrandNames;
    }

    if(!_.some(args.galleryFilters())){
        console.log('FINISHED - no filters yet', args.galleryFilters() );
        return args.allBrandNames;
    }
    
    var parentFilter =  _.find(args.galleryFilters(), { FieldName: args.parentFilterName }) 

    console.log('parent filter', parentFilter);
    
    console.log('Up town funky world', args.galleryFilters(), JSON.stringify(args.galleryFilters()), parentFilter);

    var selectedParentNames = parentFilter.FilterValues();

    console.log('selectedParentNames', selectedParentNames);

    var selectedParentValues  = _.some(selectedParentNames) 
                                    ?  _(args.categories).keyBy('name').at(selectedParentNames).value()
                                    : args.categories;

    console.log('selectedParentValues', selectedParentNames);

    var availableFilterValues = _.flatMap(selectedParentValues,'children')

    console.log('availableFilterValues', availableFilterValues);

    var availableFilterNames  = _(availableFilterValues).map('name').sort().uniq().value();

    console.log('availableFilterNames', availableFilterNames);


    console.error('mapping ' + args.thisFilterName, availableFilterNames);
    
    return availableFilterNames;
}

var topMostNode = function (args) {
    
    var topMost;

    _(args.filterRelationships).each(function(rel){
        
        var fil = _.find(args.galleryFilters(), { FieldName: rel.name  } );

        if(!fil){
            console.error('invalid filter', rel.name, args.galleryFilters());
            throw 'invalid thing ' + rel.name;
        } 

        var vals = fil.FilterValues()

        var some = _.some(vals)
        
        if(!topMost && some){
            
            topMost = fil;
        }

        console.log('Finding topmost', topMost, rel.name,some ? 'SOME' : 'none');
    })
    
    return topMost;
}

var higherThan = function(filterRelationships, fieldNameA, fieldNameB){

    var indexA = _.findIndex(filterRelationships, { name: fieldNameA } )
    ,   indexB = _.findIndex(filterRelationships, { name: fieldNameB } )
    ,   higher = indexA < indexB

    console.log('~', fieldNameA, 'higher than', fieldNameB, higher, '~');

    return higher;
    
}

, updateObject = function (name, filterNames) {

    return { name: name , filterNames: filterNames }
    
}
, enableObject = function (name, enabled) {

    return { name: name , enabled: enabled }
    
}
, filterNamesFromFilters = function (filters, cascadeName) {
    
    var names = { root: '[Root]' }
    ,  assign = function (x) { names[_.replace(x,' ', '')] = x }

    _(filters).filter({CascadeSet: cascadeName}).orderBy('Sequence').map('FieldName').each(assign);

    return names;

}
, filterRelationshipsFromFilters = function (filters, cascadeName) {
   
    var parent, array = [] 
    , assign = function (fieldName) {
        
        var next = { name: fieldName, parent: parent ? parent.name : '[Root]', child: undefined };
        parent && _.assign(parent, { child: fieldName });
        array.push(next);
        parent = next;
    }
    
    _(filters).filter({CascadeSet: cascadeName}).orderBy('Sequence').map('FieldName').each(assign);
    
    return array;
}
, enabledStateFromFilter = function (filterName, filterNames, galleryFilters, filterRelationships){

    var ret = enableObject(filterName);

    if(filterName === filterNames.root) return ret;

    var getFilter = function(name){ 

        console.error('Get filter', name);

        return _.find(galleryFilters, { FieldName: name }) || { FilterValues : _.noop };
    }        
    
    var hasSome = function(name){ 
        
        var filter = getFilter(name);
        console.log(name , filter, filter.FilterValues());
        return _.some(filter.FilterValues());        
    }
    
    var included = _(filterNames).omit(filterNames.root).includes(filterName);

    if(!included){
        ret.enabled = true;
        return ret;
    } 


    if(global.isInternetExplorer){

        var filter = getFilter(filterName);
        
        var count = _.size(filter.FixedFilterValues);
        
        filter.optionsCountExceeded(count > 999);
        
        if(filter.optionsCountExceeded()){
            
            console.log('Enabled', filter.FieldName, count, '=== Too Many Options for Internet Explorer ===');
            ret.enabled = false;
            return ret;
        }
        else console.log('Enabled', filter.FieldName, count, '=== Internet Explorer might cope ===');
    }

    ret.enabled = hasSome(filterName)
                        || _(filterRelationships)
                            .slice(_.findIndex(filterRelationships, { name: filterName }) + 1 )
                            .map(function(rel){ return !hasSome(rel.name)}) 
                            .every()

    console.log('Enabled', filterName, ret.enabled, '================================================');

    return ret;    
}

module.exports = {

    conditionalFilterValues : conditionalFilterValues

    , filterNamesFromFilters : filterNamesFromFilters

    , filterRelationshipsFromFilters : filterRelationshipsFromFilters

    , prepare : function(filters, mapping, cascadeName){
                
        var nodes               = {}
        ,   names               = {}
        ,   filterNames         = filterNamesFromFilters(filters, cascadeName)
        ,   filterRelationships = filterRelationshipsFromFilters(filters, cascadeName)

        nodes[filterNames.root] = mapping.children;

        _(filterRelationships).each(function (filter) {
                
            nodes[filter.name]       = _.flatMap(nodes[filter.parent], 'children');

            console.error('mapping nodes', nodes[filter.name]);
            
            names[filter.name] = _(nodes[filter.name]).map('name').sort().uniq().value()
            
            console.error('mapping names', names[filter.name]);
        })

        console.log('nodes hash', JSON.stringify(nodes));
        console.log('names hash', JSON.stringify(names));

        return { name: cascadeName, nodes: nodes , names : names , filterNames : filterNames, filterRelationships : filterRelationships }

    }
    , cascade : function (args) {
            
        var topMost = topMostNode(args);

        console.log('CASCADE', args.name ,'topmost', topMost );

        var cascadeSub = function(rel){

            var filter = _.find(args.galleryFilters() , { FieldName: rel.name } );
            
            console.log(' cascade sub ' , filter );
                        
            if(!topMost) {
                
                console.log('all filters all values');
                return updateObject(rel.name, args.names[rel.name]);
            }

            if(rel.parent === args.filterNames.root){

                console.log('WE ARE THE TOPMOST 0', rel.name);

                var nodesAtThisLevel = args.nodes[rel.name];

                console.log('nodes at this level', nodesAtThisLevel);

                var selectedValues = filter.FilterValues();

                console.log('selected values', selectedValues);

                filter.SelectedNodes = _(nodesAtThisLevel).keyBy('name').at(filter.FilterValues()).value()

                console.log('selected nodes', filter.SelectedNodes);

                return updateObject(rel.name, args.names[rel.name]);
            }

            if(higherThan(args.filterRelationships, rel.name, topMost.FieldName) ) return updateObject(rel.name, ['nothing here to select']);
                 
            if(topMost.FieldName === rel.name){

                if(!_.some(filter.FilterValues())) {

                    console.error(rel)
                    console.warn(filter)
                    throw 'expected filter values';
                }

                console.log('WE ARE THE TOPMOST 1', rel.name);

                var nodesAtThisLevel = args.nodes[rel.name];

                console.log('nodes at this level', nodesAtThisLevel);

                filter.SelectedNodes = _(nodesAtThisLevel).keyBy('name').at(filter.FilterValues()).value()

                console.log('selected nodes', filter.SelectedNodes);

                return updateObject(rel.name, args.names[rel.name]);
            }

            var parentFilter = _.find(args.galleryFilters() , { FieldName: rel.parent } ); 

            if(!parentFilter || !parentFilter.SelectedNodes){

                console.error('expected parent with selected nodes', parentFilter );
                throw 'expected parent'
            }

            console.log('selected nodes', parentFilter.SelectedNodes);
                        
            var nodesAtThisLevel = _.flatMap(parentFilter.SelectedNodes,'children')

            console.log('nodesAtThisLevel', nodesAtThisLevel);

            var availableFilterNames  = _(nodesAtThisLevel).map('name').sort().uniq().value();

            console.log('availableFilterNames', availableFilterNames);            

            var noLongerValidValues = _.difference(filter.FilterValues(), availableFilterNames);

            if(_.some(noLongerValidValues)){

                console.log('these values no longer valid' , noLongerValidValues)
                filter.FilterValues( _.difference(filter.FilterValues(),noLongerValidValues) ) 
            }

            console.log('nodes at this level', nodesAtThisLevel);

            filter.SelectedNodes =  _.some(filter.FilterValues())
                                        ? _(nodesAtThisLevel).keyBy('name').at(filter.FilterValues()).value()
                                        : nodesAtThisLevel;

            console.log('selected nodes', filter.SelectedNodes);            

            return updateObject(rel.name, availableFilterNames);
        }

        return _.map(args.filterRelationships, cascadeSub);
    }
    

    , enabledStateFromFilter : enabledStateFromFilter

    , enabledUpdatesFromSet: function (set) {
                                
        return _.map(set.filterNames, function (filterName) {
            
            return enabledStateFromFilter(filterName, set.filterNames, set.galleryFilters(), set.filterRelationships);
        })
    
    }     

    , CascadeSetNamesFromFilters : function (filters) {

        var cascadeSets = _(filters).map('CascadeSet').uniq().compact().sort().value();
        
        console.log('cascade sets from filtrs', filters, cascadeSets);

        return cascadeSets;      
    }

    , cascadeSetNameFromFilter: function(filter, cascadeSets){

       var set = _.find(cascadeSets, function (set) { return _.includes(set.filterNames, filter.FieldName) });

       console.log('cascadeSet ', set );

       return set ? set.name : undefined; 

    }
}